module.exports = __webpack_public_path__ + "img/9.120.0-1-mobile.91d9008f.png";